var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.styles['input-dropdown']},[(!_vm.isCategorySelected)?_c('GlobalSearchComponentsSearchCategoriesComponent'):_vm._e(),_vm._v(" "),_c('GlobalSearchComponentsSearchBodyComponent'),_vm._v(" "),_c('GlobalSearchComponentsSearchFooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }